import React, { useEffect, useState } from 'react';
import { Clock, Target, TrendingUp } from 'lucide-react';
import api from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Progress } from './ui/progress';

export default function TimeStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDailyStats();
    const interval = setInterval(fetchDailyStats, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const fetchDailyStats = async () => {
    try {
      const response = await api.get('/stats/time/daily');
      setStats(response.data);
    } catch (err) {
      console.error('Erro ao buscar estatísticas:', err);
    } finally {
      setLoading(false);
    }
  };

  const formatMinutes = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return hours > 0 ? `${hours}h ${mins}min` : `${mins}min`;
  };

  if (loading) {
    return (
      <Card className="shadow-md border-2 border-blue-200 dark:border-blue-800">
        <CardContent className="p-6">
          <div className="animate-pulse space-y-3">
            <div className="h-4 bg-slate-200 rounded w-1/2"></div>
            <div className="h-8 bg-slate-200 rounded w-1/3"></div>
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!stats) return null;

  const progressPercent = stats.progress_percent || 0;
  const totalMinutes = stats.total_minutes || 0;
  const goalMinutes = stats.goal_minutes || 240;

  return (
    <Card className="shadow-md border-2 border-blue-200 dark:border-blue-800" data-testid="time-stats-card">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg text-slate-900 dark:text-slate-100">
          <Clock className="w-5 h-5 text-blue-600" />
          Tempo Estudado Hoje
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <div className="text-4xl font-bold text-blue-600 dark:text-blue-400" data-testid="time-today-value">
            {formatMinutes(totalMinutes)}
          </div>
          <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">
            Meta: {formatMinutes(goalMinutes)}
          </p>
        </div>

        <div>
          <div className="flex justify-between items-center mb-2">
            <span className="text-sm font-medium text-slate-700 dark:text-slate-300">Progresso</span>
            <span className="text-sm font-bold text-blue-600">{progressPercent}%</span>
          </div>
          <Progress value={Math.min(progressPercent, 100)} className="h-2" />
        </div>

        <div className="text-sm text-slate-600 dark:text-slate-400">
          {progressPercent >= 100 ? (
            <span className="text-green-600 font-medium">Meta atingida!</span>
          ) : (
            <span>Faltam {formatMinutes(Math.max(0, goalMinutes - totalMinutes))}</span>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
